import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ProfileMenuComponent } from '@sbe-spinoff-client/app-shell';

/**
 * 헤더 우측 계정 드롭다운 — 로그아웃·연동 관리 등 계정 전용 항목만 담당한다.
 *
 * 단체 컨텍스트 전환은 좌측 `app-context-switcher`(shellToolbarContext)가 전담한다 —
 * sms/commerce/timetable의 좌(컨텍스트)/우(계정) 분리와 동일 구조다.
 *
 * 아바타 트리거·헤더·로그아웃은 `@sbe-spinoff-client/app-shell`의 `ProfileMenuComponent`에
 * 위임한다(로그인 가능한 모든 앱이 같은 드롭다운을 쓰도록 통일, 2026-08-12).
 */
@Component({
  selector: 'app-account-menu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatDividerModule, MatIconModule, MatMenuModule, ProfileMenuComponent],
  templateUrl: './account-menu.component.html',
})
export class AccountMenuComponent {
  readonly userName = input<string | null>(null);
  readonly logoutRequested = output<void>();

  protected readonly user = computed(() => ({ name: this.userName() }));
}
